const EXPRESSION_PATTERN = /^[\d+\-*/.()% ]*$/;
const PLAIN_NUMBER_PATTERN = /^[\d.]*$/;

// Returns null for characters a calculator field cannot hold; calculator results (no nativeEvent) are rounded.
export const normalizeCalculatorValue = (e, decimals = 2) => {
    const { value } = e.target;
    if (!EXPRESSION_PATTERN.test(value)) return null;
    if (e.nativeEvent || !PLAIN_NUMBER_PATTERN.test(value)) return value;
    const factor = 10 ** decimals;
    return String(Math.round(Number(value) * factor) / factor);
};

// A value with operator characters that is still not a number, e.g. "100/3" or "5+"; a plain "-5" is a number.
export const hasUnevaluatedExpression = (...values) => values.some((value) => {
    const text = String(value ?? '');
    return /[+\-*/()% ]/.test(text) && Number.isNaN(Number(text));
});

// Calculator events carry no input name, so the name is supplied here for handlers that read e.target.name.
export const withCalculator = (name, handler, decimals = 2) => (e) => {
    const value = normalizeCalculatorValue(e, decimals);
    if (value === null) return;
    handler({ target: { name, value }, nativeEvent: e.nativeEvent });
};
